// GLOBAL
enum StartProcessE {
  CREATE = 'CREATE',
  REASSIGN = 'REASSIGN',
  REMOVE = 'REMOVE',
}

enum SignOperationCodeE {
  CREATE = 'CREATE',
  CREATE_AND_UNASSIGN = 'CREATE_AND_UNASSIGN',
  CREATE_AND_REMOVE = 'CREATE_AND_REMOVE',
  REASSIGN = 'REASSIGN',
}

enum AUTH_TOOLS {
  NONE = 'NONE',
  CASE_MOBILE = 'CASE_MOBILE',
  SMS = 'SMS',
  GRID_CARD = 'GRID_CARD',
  GEORGE_TOKEN = 'GEORGE_TOKEN',
}

enum POLLING_STATE {
  DONE = 'DONE',
  REJECTED = 'REJECTED',
  PROCESSING = 'PROCESSING',
}

export { StartProcessE, SignOperationCodeE, AUTH_TOOLS, POLLING_STATE };
